// import { ICoreAppOnboardingState } from "@/apps/core-app-onboarding/types/ICoreAppOnboardingState";

const getters = {};

export default getters;
